import moment from 'moment';

const isSameDate = (first, second) =>
moment.unix(first).utc().isSame(moment.unix(second).utc(), 'day');

export { isSameDate };